import { BellNotification, NavArrowRight } from 'iconoir-react';
import { FunctionComponent } from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import STATUS_PAGE_URL from '@savgroup-front-common/core/api/StatusPage/config';
import {
  Button,
  ButtonLink,
} from '@savgroup-front-common/core/atoms/button';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { useIsSuperAdmin } from '@savgroup-front-common/core/hooks';
import { BaseErrorBoundary } from '@savgroup-front-common/core/molecules/ErrorBoundary';
import { SettingsIcon } from '@savgroup-front-common/core/protons/icons';

import { $GearContainer, $MaintenanceScreen } from './MaintenanceScreen.styles';
import messages from './messages';

interface MaintenanceScreenProps {
  onClose: () => void;
}

const MaintenanceScreen: FunctionComponent<MaintenanceScreenProps> = ({
  onClose,
}) => {
  const isSuperAdmin = useIsSuperAdmin();

  return (
    <$MaintenanceScreen>
      <BaseErrorBoundary
        isFullScreen
        titleMessage={messages.scheduledMaintenanceTitle}
        bodyMessage={messages.scheduledMaintenanceBody}
        icon={
          <$GearContainer>
            <SettingsIcon />
            <SettingsIcon />
          </$GearContainer>
        }
      >
        <Row>
          <Col>
            <ButtonLink
              href={STATUS_PAGE_URL}
              isExternal
              target="_blank"
              rel="noreferrer"
              icon={<BellNotification />}
              primary
            >
              <SafeFormattedMessageWithoutSpread message={messages.seemore} />
            </ButtonLink>
          </Col>
          {isSuperAdmin && (
            <Col>
              <Button
                primary
                icon={<NavArrowRight />}
                type={BUTTON_TYPES.BUTTON}
                onClick={onClose}
              >
                <SafeFormattedMessageWithoutSpread
                  message={messages.scheduledMaintenanceByPass}
                />
              </Button>
            </Col>
          )}
        </Row>
      </BaseErrorBoundary>
    </$MaintenanceScreen>
  );
};

export default MaintenanceScreen;
